export class Step3 {

    public getspan5 = 'form.mapa_at.getspan5';
    public getspan6 = 'form.mapa_at.getspan6';
    public getcriterecdc = 'form.mapa_at.getcriterecdc';
    public criterepondere = 'form.mapa_at.criterepondere';
    public getcritere = 'form.mapa_at.getcritere';
    public getcriterepct = 'form.mapa_at.getcriterepct';
    public getcriterelibre = 'form.mapa_at.getcriterelibre';
    public getcritereprix = 'form.mapa_at.getcritereprix';
    public getaddcritere = 'form.mapa_at.getaddcritere';
    public getdeletecritere = 'form.mapa_at.getdeletecritere';
}
